import * as Scrivito from "scrivito"

import { baseUrlForSite } from "./baseUrlForSite"

const DEFAULT_SITE_ID = "de"

interface SiteForUrlResponse {
  siteId: string
  baseUrl: string
}

export const siteForUrl = (url: string): SiteForUrlResponse => {
  const pathPrefix = new URL(url).pathname.split("/")[1]
  const result: SiteForUrlResponse = {
    siteId: DEFAULT_SITE_ID,
    baseUrl: baseUrlForSite(DEFAULT_SITE_ID)
  }
  if (!pathPrefix) {
    return result
  }

  const expectedHomepage = Scrivito.Obj.onAllSites()
    .where("_objClass", "equals", "Homepage")
    .and("siteUrlPrefix", "equals", pathPrefix)
    .take(1)[0]

  result.siteId = expectedHomepage
    ? expectedHomepage.siteId() || DEFAULT_SITE_ID
    : pathPrefix
  result.baseUrl = baseUrlForSite(result.siteId)
  return result
}
